import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const adminV2Routes = [
    // PENDAFTAR
    {
        key: 'v2.pendaftar',
        path: `${APP_PREFIX_PATH}/v2/pendaftar`,
        component: React.lazy(() => import('views/v2/admin/pendaftar')),
    },
    {
        key: 'v2.pendaftar.validasi-berkas',
        path: `${APP_PREFIX_PATH}/v2/pendaftar/validasi-berkas`,
        component: React.lazy(() => import('views/v2/admin/pendaftar/validasi-berkas')),
    },
    {
        key: 'v2.pendaftar.data-pembayaran',
        path: `${APP_PREFIX_PATH}/v2/pendaftar/data-pembayaran`,
        component: React.lazy(() => import('views/v2/admin/pendaftar/data-pembayaran')),
    },
    {
        key: 'v2.pendaftar.data-pembayaran.detail',
        path: `${APP_PREFIX_PATH}/v2/pendaftar/data-pembayaran/detail`,
        component: React.lazy(() => import('views/v2/admin/pendaftar/data-pembayaran/detail')),
    },
    {
        key: 'v2.pendaftar.validasi-berkas.update',
        path: `${APP_PREFIX_PATH}/v2/pendaftar/validasi-berkas/update`,
        component: React.lazy(() => import('views/v2/admin/pendaftar/validasi-berkas/update')),
    },

    // PENGATURAN
    {
        key: 'v2.pengaturan',
        path: `${APP_PREFIX_PATH}/v2/pengaturan`,
        component: React.lazy(() => import('views/v2/admin/pengaturan')),
    },
    {
        key: 'v2.pengaturan.periode-pendaftaran',
        path: `${APP_PREFIX_PATH}/v2/pengaturan/periode_pendaftaran`,
        component: React.lazy(() => import('views/v2/admin/pengaturan/periode_pendaftaran')),
    },
    {
        key: 'v2.pengaturan.periode-pendaftaran.add',
        path: `${APP_PREFIX_PATH}/v2/pengaturan/periode_pendaftaran/add`,
        component: React.lazy(() => import('views/v2/admin/pengaturan/periode_pendaftaran/add')),
    },
    {
        key: 'v2.pengaturan.periode-pendaftaran.edit',
        path: `${APP_PREFIX_PATH}/v2/pengaturan/periode_pendaftaran/edit`,
        component: React.lazy(() => import('views/v2/admin/pengaturan/periode_pendaftaran/edit')),
    },
    {
        key: 'v2.pengaturan.periode-pendaftaran.detail',
        path: `${APP_PREFIX_PATH}/v2/pengaturan/periode_pendaftaran/detail`,
        component: React.lazy(() => import('views/v2/admin/pengaturan/periode_pendaftaran/detail')),
    },

    {
        key: 'v2.pengaturan.pendaftaran-pmb',
        path: `${APP_PREFIX_PATH}/v2/pengaturan/pmb_pendaftaran`,
        component: React.lazy(() => import('views/v2/admin/pengaturan/pengaturan_pmb')),
    },

    // PENGATURAN
    {
        key: 'v2.kelulusan',
        path: `${APP_PREFIX_PATH}/v2/kelulusan`,
        component: React.lazy(() => import('views/v2/admin/kelulusan')),
    },
    {
        key: 'v2.kelulusan.generate_mahasiswa',
        path: `${APP_PREFIX_PATH}/v2/kelulusan/generate-mahasiswa`,
        component: React.lazy(() => import('views/v2/admin/kelulusan/generate_mahasiswa')),
    },
    {
        key: 'v2.kelulusan.pembatalan_nim',
        path: `${APP_PREFIX_PATH}/v2/kelulusan/pembatalan-nim`,
        component: React.lazy(() => import('views/v2/admin/kelulusan/pembatalan_nim')),
    },

    // PENGATURAN
    {
        key: 'v2.referensi',
        path: `${APP_PREFIX_PATH}/v2/referensi`,
        component: React.lazy(() => import('views/v2/admin/referensi')),
    },
    {
        key: 'v2.referensi.pendaftaran',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendaftaran`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendaftaran')),
    },
    {
        key: 'v2.referensi.pendaftaran.gelombang',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendaftaran/gelombang`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendaftaran/gelombang')),
    },
    {
        key: 'v2.referensi.pendaftaran.jalur_pendaftaran',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendaftaran/jalur_pendaftaran`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendaftaran/jalur_pendaftaran')),
    },
    {
        key: 'v2.referensi.pendaftaran.sistem_kuliah',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendaftaran/sistem_kuliah`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendaftaran/sistem_kuliah')),
    },

    {
        key: 'v2.referensi.berita',
        path: `${APP_PREFIX_PATH}/v2/referensi/berita`,
        component: React.lazy(() => import('views/v2/admin/referensi/berita')),
    },
    {
        key: 'v2.referensi.berita.pengumuman_informasi',
        path: `${APP_PREFIX_PATH}/v2/referensi/berita/pengumuman_informasi`,
        component: React.lazy(() => import('views/v2/admin/referensi/berita/pengumuman_informasi')),
    },

    {
        key: 'v2.referensi.seleksi',
        path: `${APP_PREFIX_PATH}/v2/referensi/seleksi`,
        component: React.lazy(() => import('views/v2/admin/referensi/seleksi')),
    },
    {
        key: 'v2.referensi.seleksi.jenis_seleksi',
        path: `${APP_PREFIX_PATH}/v2/referensi/seleksi/jenis_seleksi`,
        component: React.lazy(() => import('views/v2/admin/referensi/seleksi/jenis_seleksi')),
    },
    {
        key: 'v2.referensi.seleksi.jenis_syarat',
        path: `${APP_PREFIX_PATH}/v2/referensi/seleksi/jenis_syarat`,
        component: React.lazy(() => import('views/v2/admin/referensi/seleksi/jenis_syarat')),
    },
    {
        key: 'v2.referensi.seleksi.syarat_seleksi',
        path: `${APP_PREFIX_PATH}/v2/referensi/seleksi/syarat_seleksi`,
        component: React.lazy(() => import('views/v2/admin/referensi/seleksi/syarat_seleksi')),
    },

    {
        key: 'v2.referensi.pendidikan',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendidikan`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendidikan')),
    },
    {
        key: 'v2.referensi.pendidikan.jenis_institusi',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendidikan/jenis_institusi`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendidikan/jenis_institusi')),
    },
    {
        key: 'v2.referensi.pendidikan.sekolah',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendidikan/sekolah`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendidikan/sekolah')),
    },
    {
        key: 'v2.referensi.pendidikan.perguruan_tinggi',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendidikan/perguruan_tinggi`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendidikan/perguruan_tinggi')),
    },
    {
        key: 'v2.referensi.pendidikan.prodi_perguruan_tinggi',
        path: `${APP_PREFIX_PATH}/v2/referensi/pendidikan/prodi_perguruan_tinggi`,
        component: React.lazy(() => import('views/v2/admin/referensi/pendidikan/prodi_perguruan_tinggi')),
    },

    {
        key: 'v2.referensi.wilayah',
        path: `${APP_PREFIX_PATH}/v2/referensi/wilayah`,
        component: React.lazy(() => import('views/v2/admin/referensi/wilayah')),
    },

    {
        key: 'v2.referensi.biodata',
        path: `${APP_PREFIX_PATH}/v2/referensi/biodata`,
        component: React.lazy(() => import('views/v2/admin/referensi/biodata')),
    },
    {
        key: 'v2.referensi.biodata.agama',
        path: `${APP_PREFIX_PATH}/v2/referensi/biodata/agama`,
        component: React.lazy(() => import('views/v2/admin/referensi/biodata/agama')),
    },
    {
        key: 'v2.referensi.biodata.pekerjaan',
        path: `${APP_PREFIX_PATH}/v2/referensi/biodata/pekerjaan`,
        component: React.lazy(() => import('views/v2/admin/referensi/biodata/pekerjaan')),
    },
    {
        key: 'v2.referensi.biodata.penghasilan',
        path: `${APP_PREFIX_PATH}/v2/referensi/biodata/penghasilan`,
        component: React.lazy(() => import('views/v2/admin/referensi/biodata/penghasilan')),
    },
    {
        key: 'v2.referensi.biodata.jas_almamater',
        path: `${APP_PREFIX_PATH}/v2/referensi/biodata/jas_almamater`,
        component: React.lazy(() => import('views/v2/admin/referensi/biodata/jas_almamater')),
    },

    {
        key: 'v2.referensi.pelengkap',
        path: `${APP_PREFIX_PATH}/v2/referensi/pelengkap`,
        component: React.lazy(() => import('views/v2/admin/referensi/pelengkap')),
    },
    {
        key: 'v2.referensi.pelengkap.ruang',
        path: `${APP_PREFIX_PATH}/v2/referensi/pelengkap/ruang`,
        component: React.lazy(() => import('views/v2/admin/referensi/pelengkap/ruang')),
    },
    {
        key: 'v2.referensi.pelengkap.rekomendasi',
        path: `${APP_PREFIX_PATH}/v2/referensi/pelengkap/rekomendasi`,
        component: React.lazy(() => import('views/v2/admin/referensi/pelengkap/rekomendasi')),
    },


    {
        key: 'v2.laporan',
        path: `${APP_PREFIX_PATH}/v2/laporan`,
        component: React.lazy(() => import('views/v2/admin/laporan')),
    },
    {
        key: 'v2.laporan.pendaftar.biodata',
        path: `${APP_PREFIX_PATH}/v2/laporan/pendaftar/biodata`,
        component: React.lazy(() => import('views/v2/admin/laporan/pendaftar/biodata')),
    },
    {
        key: 'v2.laporan.pendaftar/pendaftar_per_tahap',
        path: `${APP_PREFIX_PATH}/v2/laporan/pendaftar/pendaftar_per_tahap`,
        component: React.lazy(() => import('views/v2/admin/laporan/pendaftar/pendaftar_per_tahap')),
    },
    {
        key: 'v2.laporan.pendaftar.bukti_pendaftaran',
        path: `${APP_PREFIX_PATH}/v2/laporan/pendaftar/bukti_pendaftaran`,
        component: React.lazy(() => import('views/v2/admin/laporan/pendaftar/bukti_pendaftaran')),
    },
    {
        key: 'v2.laporan.pendaftar.pilihan_prodi_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/pendaftar/pilihan_prodi_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/pendaftar/pilihan_prodi_pendaftar')),
    },
    {
        key: 'v2.laporan.pendaftar.perekomendasi_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/pendaftar/perekomendasi_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/pendaftar/perekomendasi_pendaftar')),
    },

    {
        key: 'v2.laporan.kelulusan',
        path: `${APP_PREFIX_PATH}/v2/laporan/kelulusan`,
        component: React.lazy(() => import('views/v2/admin/laporan/kelulusan')),
    },
    {
        key: 'v2.laporan.kelulusan.letter_of_acceptance',
        path: `${APP_PREFIX_PATH}/v2/laporan/kelulusan/letter_of_acceptance`,
        component: React.lazy(() => import('views/v2/admin/laporan/kelulusan/letter_of_acceptance')),
    },
    {
        key: 'v2.laporan.kelulusan.surat_pernyataan_mhs_baru',
        path: `${APP_PREFIX_PATH}/v2/laporan/kelulusan/surat_pernyataan_mhs_baru`,
        component: React.lazy(() => import('views/v2/admin/laporan/kelulusan/surat_pernyataan_mhs_baru')),
    },

    {
        key: 'v2.laporan.rekapitulasi',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi')),
    },
    {
        key: 'v2.laporan.rekaputulasi.prodi_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/prodi_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/prodi_pendaftar')),
    },
    {
        key: 'v2.laporan.rekaputulasi.rekomendasi_prodi',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/rekomendasi_prodi`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/rekomendasi_prodi')),
    },
    {
        key: 'v2.laporan.rekaputulasi.sekolah_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/sekolah_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/sekolah_pendaftar')),
    },
    {
        key: 'v2.laporan.rekaputulasi.rekap_kota_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/rekap_kota_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/rekap_kota_pendaftar')),
    },
    {
        key: 'v2.laporan.rekaputulasi.laporan_daftar_questioner_pendaftar',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/laporan_daftar_questioner_pendaftar`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/laporan_daftar_questioner_pendaftar')),
    },
    {
        key: 'v2.laporan.rekaputulasi.rekap_presentasi_questioner',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/rekap_presentasi_questioner`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/rekap_presentasi_questioner')),
    },
    {
        key: 'v2.laporan.rekaputulasi.rekap_ukuran_jas_almamater',
        path: `${APP_PREFIX_PATH}/v2/laporan/rekapitulasi/rekap_ukuran_jas_almamater`,
        component: React.lazy(() => import('views/v2/admin/laporan/rekapitulasi/rekap_ukuran_jas_almamater')),
    },


    {
        key: 'v2.loginas',
        path: `${APP_PREFIX_PATH}/v2/loginas`,
        component: React.lazy(() => import('views/v2/admin/loginas')),
    },
]